class Vehicle {
  constructor(code, imei, numberPlate, ecgCode, stationId, vehicleTypeId) {
    this.code = code;
    this.imei = imei;
    this.numberPlate = numberPlate;
    this.ecgCode = ecgCode;
    this.stationId = stationId;
    this.vehicleTypeId = vehicleTypeId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allVehicles: [],
      allVehiclesForOther: [],
      vehicle: new Vehicle('', '', '', '', null, null),
      vehiclePaginationList: [],
    };
  },
  methods: {
    getListOfVehiclesForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVehicles').then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          this.allVehiclesForOther = this.$store.state.vehicleModule.allVehicles;
          if (this.$route.name == 'user') {
            this.allUserVehicles = this.allVehiclesForOther;
            this.readyUserVehicle();
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfVehiclesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfVehiclesForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllVehicles: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllVehicles').then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          this.allVehicles = this.$store.state.vehicleModule.allVehicles;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllVehicles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllVehicles();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfVehiclesWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      let searchIsBroken = null;
      if (this.searchIsBroken == 2) {
        searchIsBroken = false;
      } else if (this.searchIsBroken == 3) {
        searchIsBroken = true;
      }
      this.$store
        .dispatch('getVehiclesWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          code: this.searchCode,
          imei: this.searchIMeI,
          cityId: this.searchCityId,
          zoneId: this.searchZoneId,
          stationId: this.searchStationId,
          vehicleTypeId: this.searchVehicleTypeId,
          isBroken: searchIsBroken,
        })
        .then(() => {
          if (this.$store.state.vehicleModule.successFlag) {
            this.vehiclePaginationList = [];
            let temp = this.$store.state.vehicleModule.vehicles;
            for (let i = 0; i < temp.length; i++) {
              this.vehiclePaginationList.push({
                code: temp[i].code ? temp[i].code : '-',
                imei: temp[i].imei ? temp[i].imei : '-',
                platNumber: temp[i].numberPlate ? temp[i].numberPlate : '-',
                ecg: temp[i].ecgCode ? temp[i].ecgCode : '-',
                type: temp[i].vehicleType ? temp[i].vehicleType.title : '-',
                station: temp[i].station ? temp[i].station.title : '-',
                status: temp[i].isBroken,
                id: temp[i].id,
                qr: temp[i].qrCode ? temp[i].qrCode : '',
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.vehicleModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.vehicleModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.vehicleModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.vehicleModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfVehiclesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.vehicleModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfVehiclesWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addVehicleFunction: function () {
      if (!this.vehicle.code) {
        this.snackText = 'کد شبرنگ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicle.vehicleTypeId) {
        this.snackText = 'نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicle.stationId) {
        this.snackText = 'پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.pStart) {
        if (this.pStart.length < 2) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pMiddle) {
        if (this.pMiddle.length < 3) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pEnd) {
        if (this.pEnd.length < 2) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pEnd && this.pMiddle && this.pText && this.pStart) {
        this.vehicle.numberPlate =
          this.pStart + '-' + this.pText + '-' + this.pMiddle + '-' + this.pEnd;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addVehicle', this.vehicle).then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' وسیله نقلیه با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.vehicle = new Vehicle('', '', '', '', null, null);
          this.pStart = '';
          this.pEnd = '';
          this.pText = '';
          this.pMiddle = '';
          this.getListOfVehiclesWithPagination();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getVehicleFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getVehicle', id).then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          let temp = this.$store.state.vehicleModule.vehicle;
          this.vehicle.id = temp.id;
          this.vehicle.code = temp.code;
          this.vehicle.imei = temp.imei;
          this.vehicle.ecgCode = temp.ecgCode;
          this.vehicle.vehicleTypeId = temp.vehicleType.id;
          this.vehicle.stationId = temp.station.id;
          if (temp.numberPlate) {
            let platNumber = temp.numberPlate.split('-');
            this.pStart = platNumber[0];
            this.pText = platNumber[1];
            this.pMiddle = platNumber[2];
            this.pEnd = platNumber[3];
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getVehicleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getVehicleFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editVehicleFunction: function () {
      if (!this.vehicle.code) {
        this.snackText = 'کد شبرنگ نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicle.vehicleTypeId) {
        this.snackText = 'نوع وسیله نقلیه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.vehicle.stationId) {
        this.snackText = 'پایگاه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (this.pStart) {
        if (this.pStart.length < 2) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pMiddle) {
        if (this.pMiddle.length < 3) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pEnd) {
        if (this.pEnd.length < 2) {
          this.snackText = 'شماره پلاک وارد شده معتبر نیست';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#FF5252';
          this.snakIcon = 'mdi-information';
          this.disabelConfirm = false;
          return;
        }
      }
      if (this.pEnd && this.pMiddle && this.pText && this.pStart) {
        this.vehicle.numberPlate =
          this.pStart + '-' + this.pText + '-' + this.pMiddle + '-' + this.pEnd;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editVehicle', this.vehicle).then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfVehiclesWithPagination();
          this.snackText = ' وسیله نقلیه با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.vehicle = new Vehicle('', '', '', '', null, null);
          this.pStart = '';
          this.pEnd = '';
          this.pText = '';
          this.pMiddle = '';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteVehicleFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteVehicle', this.vehicleId).then(() => {
        if (this.$store.state.vehicleModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfVehiclesWithPagination();
          this.snackText = ' وسیله نقلیه با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.vehicleModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.vehicleModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteVehicleFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.vehicleModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
